import {
  CLAIM_UPLOAD_FLOW_SOURCE_EXISTING_CLAIM_DOCUMENT,
  useClaimUploadFlowSource,
} from '../../claimUploadFlowSource';
import { VITOLO_EXISTING_CLAIM_OPTION_NOT_SELECTED } from '../../claimFormData/newClaimFormData';
import { VITOLO_EDIT_STEP_UPLOAD_DOCUMENTS, PARAM_CLAIM_ID } from '../../edit/editClaimFormSteps';
import {
  VITOLO_STEP_EXISTING_CLAIM_QUESTION,
  VITOLO_STEP_UPLOAD_DOCUMENTS,
} from '../../new/newClaimsFormSteps';

export const useSelectExistingClaimVitoloBackButtonLink = () => {
  const [source, withSource] = useClaimUploadFlowSource();

  if (source === CLAIM_UPLOAD_FLOW_SOURCE_EXISTING_CLAIM_DOCUMENT) {
    return '/user-claims-info';
  }

  return withSource(VITOLO_STEP_EXISTING_CLAIM_QUESTION);
};

export const useSelectExistingClaimVitoloNextButtonLink = (selectedClaimId) => {
  const [, /* source */ withSource] = useClaimUploadFlowSource();

  if (!!selectedClaimId && selectedClaimId !== VITOLO_EXISTING_CLAIM_OPTION_NOT_SELECTED) {
    const nextButtonLink = VITOLO_EDIT_STEP_UPLOAD_DOCUMENTS.replace(
      PARAM_CLAIM_ID,
      selectedClaimId
    );
    return withSource(nextButtonLink);
  }

  return withSource(VITOLO_STEP_UPLOAD_DOCUMENTS);
};
